var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { compact, uniq } from "lodash";
export const to = (promise, timeout = 60) => {
    return new Promise((resolve) => {
        let timerId;
        if (timeout > 0)
            timerId = setTimeout(() => {
                resolve({ err: `timeout after ${timeout}s` });
            }, timeout * 1000);
        promise
            .then((res) => {
            if (timerId)
                clearTimeout(timerId);
            resolve({ res });
        })
            .catch((err) => {
            if (timerId)
                clearTimeout(timerId);
            resolve({ err });
        });
    });
};
export const toAll = (promiseArr, timeout = 60) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve) => {
        let timerId;
        if (timeout > 0)
            timerId = setTimeout(() => {
                resolve({
                    results: [],
                    succeed: [],
                    failed: [`timeout after ${timeout}s`],
                });
            }, timeout * 1000);
        Promise.allSettled(promiseArr)
            .then((values) => {
            if (timerId)
                clearTimeout(timerId);
            const results = values.map((v) => v.status == "fulfilled" ? v.value : null);
            const failed = values
                .filter((v) => v.status != "fulfilled")
                .map((v) => v.reason || v.value || "unknown error");
            const succeed = compact(results);
            resolve({ results, succeed, failed });
        })
            .catch((err) => {
            if (timerId)
                clearTimeout(timerId);
            resolve({ results: [], succeed: [], failed: [err] });
        });
    });
});
export const sleep = (second) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve) => {
        setTimeout(() => resolve(true), second * 1000);
    });
});
export const unique = (array) => {
    return uniq(compact(array));
};
